import { useTranslation } from "react-i18next"
import { FLEET_QUESTIONS, type FleetQuestionContext } from "./fleetTodayCopy"

// The question a user clicks is also sent to the agent. What is sent stays as
// `FLEET_QUESTIONS` builds it (prompts are not UI); only the shown label is
// translated.
const LABEL_KEYS = {
  fleetStatus: {
    topic: "app.fleetToday.topics.fleetStatus",
    question: "app.fleetToday.questions.fleetStatus",
  },
  driveTime: {
    topic: "app.fleetToday.topics.driveTime",
    question: "app.fleetToday.questions.driveTime",
  },
  routeEta: {
    topic: "app.fleetToday.topics.routeEta",
    question: "app.fleetToday.questions.routeEta",
  },
  driverMessage: {
    topic: "app.fleetToday.topics.driverMessage",
    question: "app.fleetToday.questions.driverMessage",
  },
  position: {
    topic: "app.fleetToday.topics.position",
    question: "app.fleetToday.questions.position",
  },
} as const

export type FleetTodayAsk = (action: string, question: string) => void

const rowClass =
  "flex w-full flex-col rounded-md border border-gray-200 px-3 py-1.5 text-left text-sm transition-colors hover:bg-gray-100 dark:border-gray-700 dark:hover:bg-gray-800"

const ownQuestionClass =
  "w-full px-1 py-1 text-left text-xs text-gray-500 underline hover:text-foreground"

const captionClass = "px-1 text-xs font-semibold uppercase text-gray-500"

export function FleetTodayContent({
  questionContext,
  ask,
  onOpenAgent,
}: {
  questionContext: FleetQuestionContext
  ask: FleetTodayAsk
  onOpenAgent: () => void
}) {
  const { t } = useTranslation()
  const params = {
    focusTruck: questionContext.focusTruck,
    truck: questionContext.route?.truck,
    place: questionContext.route?.place,
  }
  return (
    <div className="space-y-2 text-sm">
      <p className={captionClass}>{t("app.fleetToday.caption")}</p>
      {FLEET_QUESTIONS.flatMap(({ id, topic, text }) => {
        const question = text(questionContext)
        if (!question) return []
        const keys = LABEL_KEYS[id as keyof typeof LABEL_KEYS]
        return [
          <button
            key={id}
            type="button"
            onClick={() => ask(`question:${id}`, question)}
            className={rowClass}
          >
            <span className="text-xs text-gray-500">
              {keys ? t(keys.topic) : topic}
            </span>
            <span>{keys ? t(keys.question, params) : question}</span>
          </button>,
        ]
      })}
      <button type="button" onClick={onOpenAgent} className={ownQuestionClass}>
        {t("app.fleetToday.ownQuestion")}
      </button>
    </div>
  )
}
